/*
 * Created by jmeo at 2021-06-07
 * FileName: ImageModal.tsx
 */

import React from "react";
import ReactDom from 'react-dom';
import AsyncImg from "./AsyncImg";

type ImageModalPropsType = {
    src: any,
    onClick?: () => void
}

function ImageModal(props: ImageModalPropsType) {
    const {src, onClick} = props;
    return <div className="imgModal" onClick={() => onClick && onClick()}>
        <AsyncImg src={src} disabled={true}/>
    </div>
}

export function show(params: ImageModalPropsType) {
    const domId = 'img_modal'
    let dom = document.getElementById(domId);
    const modal = <ImageModal {...params}
                              onClick={() => {
                                  dom && dom.remove()
                              }}/>
    if (!dom) {
        dom = document.createElement('div')
        dom.setAttribute('id', domId)
        document.body.append(dom)
    }

    return ReactDom.render(modal, dom)
}

type ImageShowPropsType = {
    src: any,
    children?: any
}

export default function (props: ImageShowPropsType) {
    const {src, children} = props;

    return <div
        className="imgTip"
        onClick={() => {
            show({src})
        }}>
        {children}
    </div>

}
